<template>
  <div class="generic-logo-wrapper">
    <a style="display: inline-block; max-height: 150px">
      <img v-if="logoType === 'generic'" class="generic-logo" :src="logoPath" alt="whitelabel logo" />
      <div v-if="logoType === 'svg'" class="ferro-logo-wrapper" >
        <a style="display: inline-block; max-height: 100%">
          <img :class="classToUse" :src="logoPath" alt="ferro logo" />
        </a>
      </div>
    </a>
  </div>
</template>
<script>
import * as white from '@/components/whitelabel/white-label'
export default {
  name: 'GenericLogo',
  props: {
    // must match the name in assets
    subdomain: {
      type: String,
      required: true
    },
    height: {
      type: Number,
      required: false,
      default: 816
    },
    width: {
      type: Number,
      required: false,
      default: 1056
    },
    color: {
      type: String,
      required: false,
      default: '#1c2a4f'
    },
  },
  data () {
    return {
    }
  },
  computed: {
    logoPath() {
      if (this.domainToUse == null) {
        return undefined
      }
      const whiteLabelObj = white.whiteLabels[this.domainToUse]
      // require(imageUrl) // doesn't work - webpack needs the directory
      return require(`@/assets/${whiteLabelObj.logo}`)
    },
    logoType() {
      if (this.domainToUse == null) {
        return undefined
      }
      const whiteLabelObj = white.whiteLabels[this.domainToUse]
      return whiteLabelObj.type
    },
    domainToUse() {
      if (this.whiteLabelExists) {
        return this.subdomain
      }
      return 'app'
    },
    classToUse() {
      const domain = this.domainToUse
      const whiteLabel = white.whiteLabels[domain]
      const style = whiteLabel.styleClass || 'default-logo-svg'
      return style
    },
    whiteLabelExists() {
      const supportedWhiteLabels = white.allWhiteLabelOptions
      return supportedWhiteLabels.includes(this.subdomain)
    },
  },
  methods: {

  }
}
</script>
<style scoped lang="scss">
.generic-logo-wrapper {
  max-height: 100%;
  display: inline-block;

  .generic-logo {
    display: block;
    max-width:230px;
    max-height:81px;
    width: auto;
    height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
.hma-logo {
  display: block;
  max-width:230px;
  max-height:60px;
  width: auto;
  height: auto;
}

.ferro-logo-wrapper {
  max-height: 100%;
  display: inline-block;

  .ferro-logo {
    height: 79px;
  }
  .default-logo-svg {
    // brp 142-40
    // banking 175-70
    max-height: 70px;
    max-width: 175px;
  }
  .ferro-logo-svg {
    height: 185px;
    padding-top: 10px;
  }
}
</style>
